import type React from 'react';

import { useImageRescale } from '@vlabs/monokit/shared/lib/images';
import { DetectionOverlay } from '@vlabs/monokit/shared/ui/detection-overlay';
import { FullFrame } from '@vlabs/monokit/shared/ui/full-frame';

import { getScaledDetections } from '../../lib';
import { buildTestid } from '../../lib/utils';
import type { DetectionOverlayProps } from '../detection-overlay';
import type { FullFrameProps } from '../full-frame';

interface FullFrameWithDetectionsProps extends DetectionOverlayProps, Omit<FullFrameProps, 'children'> {
  withDetections?: boolean;
}

const displayName = 'FullFrameWithDetections';
const testid = buildTestid(displayName);

function FullFrameWithDetections({
  detections,
  src = undefined,
  withDetections = true,
  className = undefined,
  'data-testid': dataTestId,
}: FullFrameWithDetectionsProps): React.JSX.Element {
  const rescale = useImageRescale(src) ?? 1;
  let children: FullFrameProps['children'];

  if (withDetections) {
    children = (size) => <DetectionOverlay detections={getScaledDetections({ detections, rescale, size })} />;
  }

  return (
    <FullFrame
      className={className}
      src={src}
      {...testid(dataTestId)}
    >
      {children}
    </FullFrame>
  );
}

FullFrameWithDetections.displayName = displayName;

export { FullFrameWithDetections };
